import Dialog, { DialogProps } from '../Dialog';

const ErrorDialog = (props: DialogProps) => <Dialog {...props} dialogType="error" />;

export default ErrorDialog;
